import { AdminType, APIGet, APIPost, APIUrl } from "api/protocols";
import { CancelToken } from "axios";
import { ILoyaltyCustomer } from "redux/reducers/models/loyalty";


interface IGetLoyaltyCustomer {
    customer_id?: number;
    tier?: boolean; // return tier info
    limit?: number;
    offset: number;
    user?: boolean; //return customer info
    search?: string;
}


export async function GetLoyaltyCustomer(params: IGetLoyaltyCustomer, useGlobalLoader: boolean, cancelToken?: CancelToken) {
    return await APIGet<Array<ILoyaltyCustomer>>(APIUrl(AdminType.FacilityAdmin, "/customer/loyalty/customer"), params, useGlobalLoader, cancelToken);
  }

  export async function GetLoyaltyCustomerTransactions(params: {customer_id: number, limit: number; offset: number}, useGlobalLoader: boolean, cancelToken?: CancelToken) {
    return await APIGet(APIUrl(AdminType.FacilityAdmin, "/customer/loyalty/customer/transactions"), params, useGlobalLoader, cancelToken);
  }

  export async function PostCustomerLoyaltyProgramTransaction(params: {customer_id: number; points_adjustment: number}, useGlobalLoader: boolean) {
    return await APIPost(APIUrl(AdminType.FacilityAdmin, "/customer/loyalty/customer/transaction"), params, useGlobalLoader);
  }

export async function PostCustomerLoyaltyProgram(params: {customer_id: number}, useGlobalLoader: boolean) {
    return await APIPost(APIUrl(AdminType.FacilityAdmin, "/customer/loyalty/customer"), params, useGlobalLoader);
  }

  export async function GetLoyaltyCustomerExpiringPoints(params: {customer_id: number}, useGlobalLoader: boolean, cancelToken?: CancelToken) {
    return await APIGet<number>(APIUrl(AdminType.FacilityAdmin, "/customer/loyalty/customer/expiring-points"), params, useGlobalLoader, cancelToken);
  }

  export async function GetActiveLoyaltyCustomerCount(useGlobalLoader: boolean, cancelToken?: CancelToken) {
    return await APIGet<number>(APIUrl(AdminType.FacilityAdmin, "/customer/loyalty/customer/active-count"), null, useGlobalLoader, cancelToken);
  }